export default __webpack_public_path__ + "static/media/button_amazon.65669dd3.png";